export default __webpack_public_path__ + "dcfcbd1e50a97b6f0f6583a6458d9394.svg";